import {ChangeDetectionStrategy, Component, inject, signal} from "@angular/core"
import {BlenderAddonService} from "@common/services/blender-addon/blender-addon.service"
import {StartingScreenService} from "@platform/components/dialogs/onboarding-dialog/starting-screen.service"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-onboarding-dialog",
    templateUrl: "./onboarding-dialog.component.html",
    styleUrl: "./onboarding-dialog.component.scss",
})
export class OnboardingDialogComponent {
    readonly $dontShowAgain = signal(false)
    readonly $blenderAddonDownload = inject(BlenderAddonService).$download

    private readonly startingScreen = inject(StartingScreenService)

    onClose(): void {
        this.startingScreen.close()
    }

    async onHide(): Promise<void> {
        if (this.$dontShowAgain()) {
            await this.startingScreen.dismissForever()
        } else {
            this.startingScreen.close()
        }
    }
}
